import { SentryAttachment } from '@luminovo/commons';

export class DomainError extends Error {
    public readonly code: string;
    public readonly message: string;
    public readonly context: unknown;
    public readonly attachment: SentryAttachment | undefined;

    constructor({
        code,
        message,
        context,
        attachment,
    }: {
        code: string;
        message: string;
        context?: unknown;
        attachment?: SentryAttachment | undefined;
    }) {
        super(message);
        this.code = code;
        this.message = message;
        this.context = context;
        this.attachment = attachment;
    }
}
